export default __webpack_public_path__ + "static/testimonial-1-9951feaaba4f27f43ae9851043c234d3.jpg";